import options from './component';


export default {
    selector: "dtEmulatorConnectionStatus",
    options
}